@if (label) {
  <span class="label">{{ label }}</span>
}
<span class="value" [class.empty]="!value">{{ value }}</span>
